import { render, staticRenderFns } from "./wide.vue?vue&type=template&id=5c1bf718&"
import script from "./wide.vue?vue&type=script&lang=js&"
export * from "./wide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports